function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../../geom/Location';
import Polygon from '../../geom/Polygon';
import PointLocation from '../PointLocation';
import PointOnGeometryLocator from './PointOnGeometryLocator';
import GeometryCollectionIterator from '../../geom/GeometryCollectionIterator';
import GeometryCollection from '../../geom/GeometryCollection';
var SimplePointInAreaLocator = /*#__PURE__*/function () {
  function SimplePointInAreaLocator() {
    _classCallCheck(this, SimplePointInAreaLocator);
    SimplePointInAreaLocator.constructor_.apply(this, arguments);
  }
  return _createClass(SimplePointInAreaLocator, [{
    key: "locate",
    value: function locate(p) {
      return SimplePointInAreaLocator.locate(p, this._geom);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SimplePointInAreaLocator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [PointOnGeometryLocator];
    }
  }], [{
    key: "locatePointInPolygon",
    value: function locatePointInPolygon(p, poly) {
      if (poly.isEmpty()) return Location.EXTERIOR;
      var shell = poly.getExteriorRing();
      var shellLoc = SimplePointInAreaLocator.locatePointInRing(p, shell);
      if (shellLoc !== Location.INTERIOR) return shellLoc;
      for (var i = 0; i < poly.getNumInteriorRing(); i++) {
        var hole = poly.getInteriorRingN(i);
        var holeLoc = SimplePointInAreaLocator.locatePointInRing(p, hole);
        if (holeLoc === Location.BOUNDARY) return Location.BOUNDARY;
        if (holeLoc === Location.INTERIOR) return Location.EXTERIOR;
      }
      return Location.INTERIOR;
    }
  }, {
    key: "locatePointInRing",
    value: function locatePointInRing(p, ring) {
      if (!ring.getEnvelopeInternal().intersects(p)) return Location.EXTERIOR;
      return PointLocation.locateInRing(p, ring.getCoordinates());
    }
  }, {
    key: "containsPointInPolygon",
    value: function containsPointInPolygon(p, poly) {
      return Location.EXTERIOR !== SimplePointInAreaLocator.locatePointInPolygon(p, poly);
    }
  }, {
    key: "locateInGeometry",
    value: function locateInGeometry(p, geom) {
      if (geom instanceof Polygon) {
        return SimplePointInAreaLocator.locatePointInPolygon(p, geom);
      } else if (geom instanceof GeometryCollection) {
        var geomi = new GeometryCollectionIterator(geom);
        while (geomi.hasNext()) {
          var g2 = geomi.next();
          if (g2 !== geom) {
            var loc = SimplePointInAreaLocator.locateInGeometry(p, g2);
            if (loc !== Location.EXTERIOR) return loc;
          }
        }
      }
      return Location.EXTERIOR;
    }
  }, {
    key: "locate",
    value: function locate(p, geom) {
      if (geom.isEmpty()) return Location.EXTERIOR;
      return SimplePointInAreaLocator.locateInGeometry(p, geom);
    }
  }]);
}();
export { SimplePointInAreaLocator as default };
SimplePointInAreaLocator.constructor_ = function () {
  this._geom = null;
  var geom = arguments[0];
  this._geom = geom;
};